import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Sparkles } from "lucide-react";

export default function About() {
  const navigate = useNavigate();
  return (
    <div className="mx-auto max-w-2xl px-5 pt-10 md:pt-16">
      <div className="inline-flex items-center gap-2 rounded-full bg-gold-soft px-3 py-1 text-xs font-medium"><Sparkles className="h-3.5 w-3.5" /> About Jaanlo</div>
      <h1 className="mt-4 font-display text-3xl font-semibold tracking-tight md:text-4xl">You came with a question.</h1>
      <p className="mt-4 leading-relaxed text-muted-foreground">
        Jaanlo isn't a horoscope website. It's a personalized self-discovery platform built around one simple idea:
        you have a real question about your life, and traditional systems — combined with thoughtful, plain-language
        interpretation — can help you reflect on it.
      </p>
      <p className="mt-4 leading-relaxed text-muted-foreground">
        We draw on Vedic astrology, numerology and tarot. Your birth details and answers create your profile, relevant
        traditional calculations are performed, and AI translates those interpretations into clear, modern language.
        You pay only for what you want — small one-time amounts, never a subscription.
      </p>
      <p className="mt-4 leading-relaxed text-muted-foreground">
        We're transparent about what these systems are: traditional interpretations for reflection, not scientifically
        validated predictions. We'll never use fear, fake urgency, or guaranteed outcomes.
      </p>
      <Button onClick={() => navigate("/")} className="mt-8 rounded-full bg-foreground px-8 py-6 text-background btn-lift hover:bg-foreground">Ask a question</Button>
    </div>
  );
}
